export function getFromStorage<T>(key: string, parseJson?: boolean): T | null {
  try {
    const item = localStorage.getItem(key)
    
    if (!item) return null

    if (parseJson) {
      try {
        return JSON.parse(item) as T
      } catch (parseError) {
        console.log(`Failed to parse JSON from localStorage (${key}):`, parseError)
        return null
      }
    }
    return item as T
  } catch (error) {
    console.log(`Failed to get item from localStorage (${key}):`, error)
    return null
  }
}

export function setToStorage<T>(key: string, value: T): void {
  try {
    const storageValue = typeof value === 'string' ? value : JSON.stringify(value)
    localStorage.setItem(key, storageValue)
  } catch (error) {
    console.log(`Failed to set item in localStorage (${key}):`, error)
  }
}

export function removeFromStorage(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.log(`Failed to remove item from localStorage (${key}):`, error)
  }
}
